import { useEffect, useState } from 'react';

const useAuth = () => {
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const uid = localStorage.getItem('uid');
    setAuthenticated(!!token); // true si hay token
  }, []);

  return authenticated;
};

export default useAuth;